import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CssBaseline, ThemeProvider, createTheme } from '@mui/material';
import { merge } from 'lodash';
import { useMemo } from 'react';
import { customShadows } from './custom-shadows';
import { componentsOverrides } from './overrides';
import { palette } from './palette';
import { shadows } from './shadows';
import { typography } from './typography';
export default function AppThemeProvider(_a) {
    var children = _a.children;
    var baseOption = useMemo(function () { return ({
        palette: palette('light'),
        shadows: shadows('light'),
        customShadows: customShadows('light'),
        typography: typography,
        shape: { borderRadius: 8 }
    }); }, []);
    var memoizedValue = useMemo(function () { return merge(baseOption); }, [baseOption]);
    var theme = createTheme(memoizedValue);
    theme.components = merge(componentsOverrides(theme));
    return (_jsxs(ThemeProvider, { theme: theme, children: [_jsx(CssBaseline, {}), children] }));
}
